const SpecialistsPageComponent = {
    data() {
        return {
            items: [],
            loading: false,

            groups: [],
            activeGroupId: 'all',
            tabsInited: false,

            page: 1,
            limit: 12,

            baseUrl: window.appConfig?.baseUrl || '',
            plugImage: window.appConfig?.specialistsPlug || '/img/plug.jpg',
        }
    },

    computed: {
        showPagination() {
            return this.activeGroupId === 'all' || (Number(this.activeGroupId) || 0) <= 0
        },

        filteredAll() {
            const ag = this.activeGroupId

            if (ag === 'all' || (Number(ag) || 0) <= 0) {
                return this.items || []
            }

            const gid = Number(ag) || 0
            const need = `tab-g-${gid}`

            return (this.items || []).filter(sp => {
                const tabStr = String(sp?.tab || '').trim()
                if (!tabStr) return false
                return tabStr.split(/\s+/).includes(need)
            })
        },

        pagesCount() {
            const total = (this.filteredAll || []).length
            return total > 0 ? Math.ceil(total / (Number(this.limit) || 12)) : 1
        },

        rowsCount() {
            return (this.filteredAll || []).length
        },

        canShowMore() {
            return this.page < this.pagesCount
        },

        paginationItems() {
            return this.buildPagination(this.pagesCount, this.page)
        },

        visibleItems() {
            if (!this.showPagination) return this.filteredAll || []

            const p = Math.max(1, Number(this.page) || 1)
            const lim = Math.max(1, Number(this.limit) || 12)
            const start = (p - 1) * lim
            const end = start + lim

            return (this.filteredAll || []).slice(start, end)
        },
    },

    methods: {
        async loadGroups() {
            try {
                const url = window.appConfig?.routes?.getServiceGroups
                if (!url) return (this.groups = [])

                const response = await fetch(url, {
                    method: 'post',
                    headers: {
                        'X-CSRF-TOKEN': window.appConfig.csrfToken,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ page: 1, limit: 200 }),
                })

                if (!response.ok) return (this.groups = [])

                const json = await response.json()
                this.groups = Array.isArray(json?.data) ? json.data : []
            } catch (e) {
                console.error('[SpecialistsPage] loadGroups failed', e)
                this.groups = []
            }
        },

        async loadAll() {
            this.loading = true

            try {
                const response = await window.specialistsPageService.getSpecialistsPage({ limit: 500 })
                const list = response?.data ?? []
                this.items = (Array.isArray(list) ? list : []).map(row => this.normalizeItem(row))
                this.page = 1
            } catch (e) {
                console.error('[SpecialistsPage] loadAll failed', e)
                this.items = []
                this.page = 1
            } finally {
                this.loading = false
            }
        },

        renderTabs() {
            const root = this.$el
            const ul = root.querySelector('.tabs.tabs__filter')
            if (!ul) return

            Array.from(ul.querySelectorAll('.tab__link[data-dynamic="1"]')).forEach(el => el.remove())

            ;(this.groups || []).forEach(g => {
                const id = Number(g?.id) || 0
                const title = String(g?.title || '').trim()
                if (id <= 0 || !title) return

                const li = document.createElement('li')
                li.className = 'tab__link'
                li.textContent = title
                li.setAttribute('data-group-id', String(id))
                li.setAttribute('data-dynamic', '1')
                ul.appendChild(li)
            })
        },

        initTabsDom() {
            if (this.tabsInited) return this.setActiveGroupDom(this.activeGroupId)

            this.tabsInited = true

            const root = this.$el
            const ul = root.querySelector('.tabs.tabs__filter')
            if (!ul) return

            ul.addEventListener('click', e => {
                const li = e.target?.closest?.('.tab__link')
                if (!li) return

                const idRaw = String(li.getAttribute('data-group-id') || 'all').trim()
                const id = idRaw === 'all' ? 'all' : (Number(idRaw) || 0)
                this.setGroup(id)
            })

            this.setActiveGroupDom(0)
        },

        setActiveGroupDom(groupId) {
            const root = this.$el
            const tabs = Array.from(root.querySelectorAll('.tabs.tabs__filter .tab__link'))
            const gid = groupId === 'all' ? 'all' : (Number(groupId) || 0)

            tabs.forEach(t => {
                const raw = String(t.getAttribute('data-group-id') || 'all').trim()
                const id = raw === 'all' ? 'all' : (Number(raw) || 0)
                t.classList.toggle('current', id === gid)
            })
        },

        setGroup(groupId) {
            const gid = groupId === 'all' ? 'all' : (Number(groupId) || 0)
            if (gid === this.activeGroupId) return

            this.activeGroupId = gid
            this.setActiveGroupDom(gid)
            this.page = 1
        },

        showMore() {
            if (this.loading || !this.canShowMore) return
            this.page += 1
        },

        goPrev() {
            if (this.loading || this.page <= 1) return
            this.page -= 1
        },

        goNext() {
            if (this.loading || this.page >= this.pagesCount) return
            this.page += 1
        },

        goTo(page) {
            const p = Math.max(1, Number(page) || 1)
            if (this.loading || p === this.page) return
            this.page = Math.min(p, this.pagesCount)
        },

        buildPagination(pagesCount, currentPage) {
            const total = Math.max(1, Number(pagesCount) || 1)
            const current = Math.min(total, Math.max(1, Number(currentPage) || 1))

            if (total <= 8) return Array.from({ length: total }, (_, i) => i + 1)

            const items = []
            const push = v => items.push(v)

            push(1)

            const left = Math.max(2, current - 2)
            const right = Math.min(total - 1, current + 2)

            if (left > 2) push('...')

            for (let p = left; p <= right; p++) push(p)

            if (right < total - 1) push('...')

            push(total)

            return items
        },

        normalizeItem(row) {
            const professions = Array.isArray(row?.professions)
                ? row.professions.map((p) => String(p || '').trim()).filter(Boolean)
                : [];

            const profession_ids = Array.isArray(row?.profession_ids)
                ? row.profession_ids.map((x) => Number(x) || 0).filter((x) => x > 0)
                : [];

            const id = Number(row?.id || 0) || 0;
            const pid = profession_ids[0] || 0;

            const recordUrl = id
                ? (pid ? `/record?profession_id=${pid}&user_id=${id}` : `/record?user_id=${id}`)
                : '';

            return {
                id: row?.id ?? null,
                url: String(row?.url || '').trim() || '#',
                recordUrl,
                avatar: String(row?.avatar || '').trim(),
                name: String(row?.name || '').trim() || 'Специалист',
                rating: Number(row?.rating ?? 0) || 0,
                professions,
                profession_ids,
                post: String(row?.post || '').trim() || '',
                price: Number(row?.price ?? 0) || 0,
                tab: String(row?.tab || '').trim(),
            };
        },

        getAvatarUrl(avatar) {
            const a = String(avatar || '').trim()
            if (!a) return this.plugImage
            if (a.startsWith('http://') || a.startsWith('https://')) return a

            const base = String(this.baseUrl || '').replace(/\/+$/, '')
            const path = a.startsWith('/') ? a : `/${a}`

            return base ? `${base}${path}` : path
        },

        onAvatarError(e) {
            const img = e?.target
            if (!img) return
            if (img.dataset.fallbackApplied === '1') return

            img.dataset.fallbackApplied = '1'
            img.src = this.plugImage
        },

        formatPrice(price) {
            if (window.globalState?.formatPrice) return window.globalState.formatPrice(price)
            return String(Number(price) || 0)
        },
    },

    async mounted() {
        await this.loadGroups()

        this.$nextTick(() => {
            this.renderTabs()
            this.initTabsDom()
        })

        this.loadAll()
    },
}

window.SpecialistsPageComponent = SpecialistsPageComponent